/* eslint-disable @typescript-eslint/restrict-plus-operands */
import {
  type DeleteNoteResponseDto,
  type Action,
  type AsyncStateObject
} from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, NOTES_ACTION_TYPE } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<DeleteNoteResponseDto> = {
  data: { message: '' },
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined

}

const deleteNoteReducer = (state = INITIAL_STATE, action: Action<DeleteNoteResponseDto>) => {
  switch (action.type) {
    case NOTES_ACTION_TYPE.DELETE_NOTE + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case NOTES_ACTION_TYPE.DELETE_NOTE + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case NOTES_ACTION_TYPE.DELETE_NOTE + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case NOTES_ACTION_TYPE.DELETE_NOTE + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default deleteNoteReducer
